import { AbstractService } from "./ApiClient";
import { ApiRoutes } from "@typingsGenerator/ApiRoutes";
import MetricRequestDto = Cloud.RavenDB.Core.Dto.Metrics.MetricRequestDto;
import MetricsDto = Cloud.RavenDB.Core.Dto.Metrics.MetricsDto;

export default class MetricsService extends AbstractService {
    getMetrics = async (metricsRequest: MetricRequestDto): Promise<MetricsDto> => {
        const response = await this.post<MetricRequestDto, MetricsDto>(ApiRoutes.metrics.getMetrics(), metricsRequest);

        return response.data;
    };
}
